import script from "./AbaKits.vue?vue&type=script&setup=true&lang=js"
export * from "./AbaKits.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__